export default __webpack_public_path__ + "static/media/downArrowGreen.44d9d8a1.svg";